import React, {useState} from 'react';
import {View, Text, Image, Modal, TouchableOpacity, StyleSheet} from 'react-native';
import {AntDesign} from '@expo/vector-icons';
import placeholder from '../../../assets/boxchamp-box-placeholder.svg';

const BoxChampBoxImage = ({
  boxes,
  activeBoxIndex = 0,
  activeBoxId = null,
  verifiedBoxIds = [],
  boxChampEnabled = false,
}) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const boxList = boxChampEnabled && Array.isArray(boxes) ? boxes : [];
  const namedBox =
    activeBoxId == null ? null : boxList.find(b => b && b.id === activeBoxId) || null;
  const indexedBox = boxList[activeBoxIndex];
  let box = null;
  if (namedBox) {
    box = namedBox;
  } else if (indexedBox?.source === 'box_champ') {
    box = indexedBox;
  } else if (indexedBox) {
    box = boxList.find(b => b?.source === 'box_champ') ?? null;
  }

  if (!box) return null;

  const verified = Array.isArray(verifiedBoxIds) && verifiedBoxIds.includes(box.id);
  const closePreview = () => setPreviewVisible(false);
  const hasVolumeData =
    box.box_volume != null && box.packed_item_volume != null && box.efficiency != null;

  return (
    <View testID="boxchamp-box-section" style={styles.section}>
      <View style={styles.info}>
        <Text testID="boxchamp-current-box-name" style={styles.boxName}>
          {box.name}
        </Text>
        {verified && (
          <Text testID="boxchamp-box-verify-status" style={styles.verified}>
            ✓ Box verified
          </Text>
        )}
        {hasVolumeData && (
          <>
            <Text testID="boxchamp-box-volume" style={styles.volumeText}>
              Box Vol: {box.box_volume} cm³
            </Text>
            <View style={styles.productVolRow}>
              <Text testID="boxchamp-product-volume" style={styles.volumeText}>
                Product Vol: {box.packed_item_volume} cm³
              </Text>
              <Text testID="boxchamp-usage-percent" style={styles.usageText}>
                {(box.efficiency * 100).toFixed(1)}% usage
              </Text>
            </View>
          </>
        )}
      </View>
      <TouchableOpacity
        testID="boxchamp-box-image-touchable"
        disabled={!box.image}
        onPress={() => setPreviewVisible(true)}>
        <Image
          testID="boxchamp-box-image"
          defaultSource={placeholder}
          source={box.image ? {uri: box.image} : placeholder}
          style={styles.image}
        />
      </TouchableOpacity>

      <Modal
        testID="boxchamp-image-preview-modal"
        transparent
        visible={previewVisible}
        animationType="fade"
        onRequestClose={closePreview}>
        <TouchableOpacity
          testID="boxchamp-image-preview-overlay"
          style={styles.previewOverlay}
          activeOpacity={1}
          onPress={closePreview}>
          <View testID="boxchamp-image-preview-card" style={styles.previewCard}>
            <TouchableOpacity
              testID="boxchamp-image-preview-close"
              style={styles.previewCloseIcon}
              onPress={closePreview}>
              <AntDesign name="close" size={20} color="#ffffff" />
            </TouchableOpacity>
            <TouchableOpacity
              testID="boxchamp-image-preview-image-touchable"
              activeOpacity={1}
              onPress={closePreview}>
              <Image
                testID="boxchamp-image-preview-image"
                defaultSource={placeholder}
                source={box.image ? {uri: box.image} : placeholder}
                style={styles.previewImage}
              />
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#292929',
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  info: {
    flexShrink: 1,
    marginRight: 12,
  },
  boxName: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: 30,
    fontWeight: '600',
    textAlign: 'left',
    alignSelf: 'stretch',
  },
  verified: {
    color: '#4caf50',
    fontSize: 14,
    fontWeight: '600',
    marginTop: 4,
  },
  volumeText: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: 18,
    fontWeight: 'normal',
    marginTop: 2,
    textAlign: 'left',
    alignSelf: 'stretch',
  },
  productVolRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  usageText: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: 20,
    fontWeight: '600',
    marginLeft: 8,
  },
  image: {
    height: 80,
    width: 80,
    borderRadius: 5,
    resizeMode: 'cover',
  },
  previewOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.75)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  previewCard: {
    backgroundColor: 'transparent',
    maxWidth: '90%',
    maxHeight: '80%',
  },
  previewCloseIcon: {
    position: 'absolute',
    top: -12,
    right: -12,
    zIndex: 1,
    backgroundColor: '#1c1c1c',
    borderRadius: 16,
    width: 32,
    height: 32,
    alignItems: 'center',
    justifyContent: 'center',
  },
  previewImage: {
    width: 320,
    height: 320,
    maxWidth: '100%',
    borderRadius: 12,
    resizeMode: 'contain',
  },
});

export default BoxChampBoxImage;
